{
    "TelephonenosLabel": "Nº Telefone(s):",
    "AcdagentsLabel": "Agente(s) ACD:",
    "LocationLabel": "Local de\/para:",
    "LocationOptionAny": "[Qualquer chamada para\/desses locais]",
    "LocationOptionFrom": "Apenas chamadas desses locais",
    "LocationOptionTo": "Apenas chamadas para estes locais",
    "LocationalFiltering_SectionHeader": "Filtragem de localização",
    "LocationalFiltering_AnyPlaceholder": "[Any]",
    "LocationalFiltering_DevicesLabel": "Dispositivos):",
    "NAME": "LocationalFiltering",
    "TelephonenosLabelDNIS": "Número(s) de telefone \/ Número(s) DNIS:",
    "TelephonenoDescriptionsLabel": "Número de telefone Descrição(ões):",
    "AcdagentsLabel_MST": "Agente(s):"
}